
import {React, useState, useEffect} from 'react'
import { Elements, CardNumberElement, CardExpiryElement, CardCvcElement, CardElement, PaymentElement,useStripe,useElements  } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CardPaymentForm from './CardPaymentForm';



function StripePayment({setPaymentModal}) {
  
  const [paymentOptionAmount, setPaymentOptionAmount] = useState(10)
  // const stripePromise = loadStripe('const stripePromise = loadStripe('pk_test_51MgMVRAPmgE2jEzZNLL7fojhCo052rXCR634fbmKPaVZL3lM1kM4QtRUWU6RvFl2BmQMeDBucOpgQDuDBV0lJ9ov00PmEkcwVC');
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
    const CARD_ELEMENT_OPTIONS = {
      style: {
        base: {
          color: "#32325d",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#aab7c4",
          },
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a",
        },
      },
    };
    
 console.log("Amount",Math.round(paymentOptionAmount * 100))
  const options={
    mode: 'payment',
    currency: 'usd',
    amount: Math.round(paymentOptionAmount * 100), // Convert to cents
    setup_future_usage: 'off_session'
  }
  return (
    <Elements stripe={stripePromise} options={options}>
      {/* <CardElement></CardElement> */}
      <CardPaymentForm setPaymentModal={setPaymentModal}></CardPaymentForm>
    </Elements>
  )
}

export default StripePayment;
